/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Use_Original_TimingInputs */



/**
* | output |
* | --- |
* | "Use Original Timing" |
*
* @param {Use_Original_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const use_original_timing = /** @type {((inputs?: Use_Original_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Use_Original_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser le minutage original")
	if (locale === "de") return /** @type {LocalizedString} */ ("Originale Zündung verwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa la temporizzazione originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать исходное время")
	if (locale === "es") return /** @type {LocalizedString} */ ("Utilice la sincronización original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用原时序")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オリジナルのタイミングを使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल समय का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Use a sincronização original")
	return /** @type {LocalizedString} */ ("Use Original Timing")
});